import {
  ITEMS_CONTAINER_ACTION_ADD,
  ITEMS_CONTAINER_ACTION_DELETE,
  ITEMS_CONTAINER_ACTION_EDIT,
  ITEMS_CONTAINER_ACTION_VIEW,
  type PregenerationType,
  type PropertiesConfigInputContainerItemUnifiedRowActionModel,
} from '@blaze-shared/elements-domain';

import { type CalendarActionType } from './calendar.definition';

export const TABLE_ROW_ACTIONS_MAP = new Map<
  CalendarActionType,
  PropertiesConfigInputContainerItemUnifiedRowActionModel
>([
  [
    'Edit',
    {
      type: 'edit',
      label: 'Edit row',
      id: ITEMS_CONTAINER_ACTION_EDIT,
      icon: 'icon_edit_24',
      showInlineLabel: false,
    },
  ],
  [
    'Delete',
    {
      type: 'delete',
      label: 'Delete row',
      id: ITEMS_CONTAINER_ACTION_DELETE,
      icon: 'icon_trash_16',
      showInlineLabel: false,
    },
  ],
  [
    'View',
    {
      type: 'view',
      label: 'View details',
      id: ITEMS_CONTAINER_ACTION_VIEW,
      icon: 'icon_preview_16',
      showInlineLabel: false,
    },
  ],
  [
    'Create',
    {
      type: 'custom',
      label: 'Create row',
      id: ITEMS_CONTAINER_ACTION_ADD,
      icon: 'icon_add_16',
      showInlineLabel: false,
    },
  ],
]);

export const TABLE_ROW_ACTION_PATHS_MAP = new Map<CalendarActionType, string>([
  ['View', 'content.itemViewDialog'],
  ['Edit', 'content.itemEdit'],
  ['Create', 'content.itemAdd'],
  ['Delete', 'content.itemDelete'],
]);

export const CALENDAR_ROW_ACTIONS_PREGENERATION_TYPES_MAP = new Map<
  CalendarActionType,
  PregenerationType
>([
  ['View', 'view-dialog'],
  ['Edit', 'edit'],
  ['Create', 'add'],
]);
